import {
  GET_UNUSED_DEALERS,
  GET_UNUSED_DEALERS_SUCCESSFUL,
  GET_UNUSED_DEALERS_FAILED,
} from "./actionTypes";

export const GetUnusedDealers = (data) => {
  return {
    type: GET_UNUSED_DEALERS,
    payload: { data },
  };
};

export const GetUnusedDealersSuccessful = (data) => {
  return {
    type: GET_UNUSED_DEALERS_SUCCESSFUL,
    payload: { data },
  };
};

export const GetUnusedDealersFailed = (error) => {
  return {
    type: GET_UNUSED_DEALERS_FAILED,
    payload: { error },
  };
};